<template>
  <div class="smart-point-widget">
    <component v-if="resolveWidgetComponent !== 'div'" v-bind:is="resolveWidgetComponent" v-bind:transporter="transporter"></component>
    <component v-if="resolveWidgetComponent !== 'div'" v-bind:is="resolveWidgetSelectionComponent" v-bind:transporter="transporter"></component>
  </div>
</template>

<script>

import BoxNowWidget from './BoxNowWidget.vue'
import SmartPointWidgetSelection from './SmartPointWidgetSelection.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SmartPointWidget',
  components: {
    BoxNowWidget,
    SmartPointWidgetSelection
  },
  props: {
    transporter: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedTransporterObject'
    ]),
    resolveWidgetComponent () {
      if (!this.getSelectedTransporterObject) {
        return 'div'
      }

      const componentMap = {
        BOXNOW: 'BoxNowWidget'
      }

      return componentMap[this.getSelectedTransporterObject.class_name] || 'div'
    },
    resolveWidgetSelectionComponent () {
      if (!this.getSelectedTransporterObject) {
        return 'div'
      }

      const componentMap = {
        BOXNOW: 'SmartPointWidgetSelection'
      }

      return componentMap[this.getSelectedTransporterObject.class_name] || 'div'
    }
  }
}
</script>
